<template>
  <div class="ima-sign-details">

    <ima-loading-spinner v-if="sign.isLoading">
    </ima-loading-spinner>

    <div v-if="!sign.isLoading">
      <h1 class="title">
        <ima-inline-edit :value="sign.data.name" :disabled="!signIsEditable || !canEditSigns" @change="onNameChange"></ima-inline-edit>

        (ID: {{sign.data.id}})</h1>

      <div class="columns">

        <div class="column">
          <div class="box">

            <b-tabs :animated="false">

              <b-tab-item label="Autoren">
                <div class="ima-sign-details__authors">

                  <strong>Erstellt von</strong>
                  <div class="ima-sign-details__author">
                    <ima-user-info :user="sign.data.createdBy"></ima-user-info>
                    <span v-if="sign.data.createdAt">{{sign.data.createdAt | moment('DD.MM.YYYY HH:mm')}}</span>
                  </div>

                  <div v-if="sign.data.updatedBy">
                    <strong>Zuletzt bearbeitet von</strong>
                    <div class="ima-sign-details__author">
                      <ima-user-info :user="sign.data.updatedBy"></ima-user-info>
                      <span v-if="sign.data.updatedAt">{{sign.data.updatedAt | moment('DD.MM.YYYY HH:mm')}}</span>
                    </div>
                  </div>
                </div>
              </b-tab-item>

              <b-tab-item label="Messe">
                <ima-exhibition-info :exhibition="sign.data.exhibition" :editable="canChangeSignExhibition" @change="onExhibitionChange"></ima-exhibition-info>
              </b-tab-item>

            </b-tabs>

          </div>
        </div>

        <div class="column">
          <div class="box">
            <b-tabs :animated="false">

              <b-tab-item label="Status">
                <ima-sign-status :status="sign.data.status"></ima-sign-status>
              </b-tab-item>
            </b-tabs>
          </div>
        </div>

        <div class="column">
          <div class="box">
            <b-tabs :animated="false">
              <b-tab-item label="Anmerkungen">
                <textarea class="textarea" :disabled="!canEditSigns" :value="sign.data.comment" @change="(event)=>onCommentChange(event.target.value)" placeholder="Keine Anmerkungen vorhanden"></textarea>
              </b-tab-item>
            </b-tabs>
          </div>
        </div>

      </div>

      <div class="box">

        <div class="tabs ima-sign-details__variant-tabs">
          <ul>
            <li class="ima-sign-details__variant-tab" v-for="variant in variants.data" v-bind:key="variant.id" @click="selectVariant(variant)" :class="{'is-active' : isCurrentVariant(variant)}">
              <a>
                <span>{{variant.name}}</span>
                <span v-if="variant.isDefault" class="tag is-secondary is-small">STANDARD</span>
              </a>
            </li>
            <li>
              <button v-if="canCreateVariants" class="button icon-button" type="button" @click="openVariantModal()" :disabled="!signIsEditable">
                <b-icon icon="add_circle" size="is-medium"></b-icon>
              </button>
            </li>
          </ul>
        </div>
        <ima-sign-editor>
        </ima-sign-editor>
      </div>

    </div>
  </div>
</template>


<script>
import { mapActions, mapState, mapMutations } from 'vuex'

import {
  fetchSign,
  updateSign,
  saveSign,
  resetSign
} from '@/store/modules/sign'
import { selectVariant } from '@/store/modules/variant'
import { openVariantModal } from '@/store/modules/modals'
import {
  canEditSigns,
  canCreateVariants,
  signIsEditable,
  canChangeSignExhibition
} from '@/services/permissions'

import ExhibitionInfo from '@/components/ExhibitionInfo'
import InlineEdit from '@/components/InlineEdit'
import LoadingSpinner from '@/components/LoadingSpinner'
import SignEditor from '@/components/SignEditor'
import SignStatus from '@/components/SignStatus'
import UserInfo from '@/components/UserInfo'

export default {
  name: 'ima-sign-details',
  props: ['id', 'variantId'],
  components: {
    'ima-exhibition-info': ExhibitionInfo,
    'ima-inline-edit': InlineEdit,
    'ima-loading-spinner': LoadingSpinner,
    'ima-sign-editor': SignEditor,
    'ima-sign-status': SignStatus,
    'ima-user-info': UserInfo
  },
  data () {
    return {}
  },
  methods: {
    ...mapMutations([updateSign, openVariantModal]),
    ...mapActions([fetchSign, selectVariant, saveSign, resetSign]),
    isCurrentVariant (variant) {
      return (
        this.variant && this.variant.data && this.variant.data.id === variant.id
      )
    },
    onNameChange (name) {
      this.updateSign({ name })
      this.saveSign(this.sign.data)
    },
    onCommentChange (comment) {
      this.updateSign({ comment })
      this.saveSign(this.sign.data)
    },
    onExhibitionChange (exhibition) {
      this.updateSign({ exhibition, exhibitionId: exhibition.id })
      this.saveSign(this.sign.data)
    }
  },
  computed: {
    ...mapState(['sign', 'variants', 'variant']),
    canEditSigns () {
      return canEditSigns()
    },
    signIsEditable () {
      return signIsEditable()
    },
    canCreateVariants () {
      return canCreateVariants()
    },
    canChangeSignExhibition () {
      return canChangeSignExhibition()
    }
  },
  created () {
    this.fetchSign({ id: this.id }).then(() => {
      // Select optional variant by id from url/router
      if (this.variantId) {
        const match = this.variants.data.find(
          ({ id }) => id === parseInt(this.variantId, 10)
        )
        if (match) {
          this.selectVariant(match)
        }
      }
    })
  },
  destroyed () {
    this.resetSign()
  }
}
</script>


<style scoped lang="scss">
.ima-sign-details {
  &__authors {
    display: flex;
    flex-direction: column;
  }

  &__author {
    align-items: center;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    padding: 0.5rem 0;
    margin: 0 0.5rem 0.5rem;
  }

  &__variant-tabs {
    margin-bottom: -1px;
  }

  &__variant-tab {
    .tag {
      font-size: 0.6rem;
      margin-left: 0.5rem;
      position: relative;
      top: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignDetails.vue